import LocalStorageKeys from '../cache/LocalStorageKeys'

const FILE = 'captureRequestParams.js'

const captureRequestParams = (context) => {
  console.log(FILE)
  let params = new URLSearchParams(window.location.search)
  if (params.get('apihost')) {
    context.apiHost = params.get('apihost')
    localStorage.setItem(LocalStorageKeys.APIHost, context.apiHost)
  }
}

export default captureRequestParams
